var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84126 2.49998V3.99999L1.7049 4V11.5H9.54581V8.49999H11.114L11.114 13H0.136719V2.5L4.84126 2.49998ZM13.4663 0.25V6.25H11.8981V2.81061L5.3957 9.03033L4.28683 7.96967L10.7892 1.74998L7.19354 1.75V0.25H13.4663Z",
    fill: "#3B58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/Combined-Shape.b3a76bc4c84f439ca9625d803f6b2e49.svg";
export { ForwardRef as ReactComponent };